import { useMediaQuery, useTheme } from "@mui/material";

/**
 * True below the `sm` breakpoint — i.e. phone-sized viewports only.
 * For the wider "mobile" range (below `md`, includes tablets) use `useIsMobile`.
 */
export const useIsPhone = () => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down("sm"));
};
